type ValResult = boolean | string
type ValCallback<T> = (value: T) => ValResult
type StrValCallback = (value: string) => ValResult

export default {
  $t: function (key: string): string {
    return key
  },
  required (msg?: string): StrValCallback {
    const req = msg || this.$t('val.required')
    return v => !!v || req
  },
  length (len: number): StrValCallback {
    const req = this.$t('Invalid character length, required')
    return v => (v || '').length >= len || req
  },
  createConfirm (msg: string, compareVal: string): StrValCallback {
    return v => v === compareVal || msg
  },
  email (msg?: string): StrValCallback {
    const req = msg || this.$t('val.invalidEmail')
    return v => !!(v || '').match(/(\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*)/) || req
  },
  regExp (pattern: string, msg?: string): StrValCallback {
    const req = msg || this.$t('val.invalidFormat')
    return v => !!(v || '').match(new RegExp(pattern)) || req
  },
  requireAll (...fields: Array<string>) {
    const obj = {} as any
    for (const index in fields) {
      obj[fields[index]] = this.required()
    }
    return obj
  }
}
